import { render, staticRenderFns } from "./reservationListReservationDetails.vue?vue&type=template&id=50c0d9e9"
import script from "./reservationListReservationDetails.vue?vue&type=script&lang=js"
export * from "./reservationListReservationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports